module.exports = __webpack_public_path__ + "static/media/Instructions1.e68d4562.png";